import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import { Link } from "react-router-dom";
import LoginForm from "../forms/LoginForm";
import { login, isTokenValid } from "../../actions/auth";
import settings, { getApiHost } from "../../settings";
import { LPPOLICE } from "./Const";
import "../../App.css";
import { resetAppErrorMessage } from "../../actions/appMessage";
import TopNavigation from "../navigation/TopNavigation";
import { getContact } from "../navigation/Contact";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    axios
      .post(
        `${getApiHost(settings.env)}/maintenanceMessages.aspx`,
        {
          appName: settings.appName,
        },
        {
          async: true,
        }
      )
      .then((result) => {
        if (
          result.data &&
          result.data.Message === "success" &&
          result.data.Data.length > 0
        ) {
          this.setState({ data: result.data.Data });
        }
      });

    this.state = {
      loginError: "",
      data: [],
    };
  }

  submit = (data) =>
    this.props
      .login(data)
      .then(() => {
        if (localStorage.appToken) {
          localStorage.removeItem("loginFailed");
          // window.location.href = `../securityquestions`;
          window.location.href = `../securitytoken`;
          this.setState({ loginError: "" });
        }
      })
      .catch((err) => {
        console.log("response err - ", err.response, err.message);
        if (err.message === "Network Error")
          this.setState({ loginError: "Underlying services are busy. Please try at a later time. Contact support for more details." })
      });

  render() {
    const messages = [];
    _.forEach(this.state.data, (message) => {
      messages.push(message);
    });
    // messages.push('<p style="color:red; font-size: 14px;">We will be performing routine maintenance on 5/11/2025 starting at 6:30 am ET. The expected duration is about an hour. Thank you for being patient as we improve our services.</p>');
    return (
      <div>
        <TopNavigation />
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div className="container-fluid padding-top-10">
            <div className="row login-box">
              <div className="col-lg-1 col-md-1 col-sm-1" />
              <div className="col-lg-5 col-md-5 col-sm-5 login-box-left">
                <div className="padding-top-10" />

                {/* <h2 className="font-family">Login into your account</h2> */}

                <LoginForm
                  submit={this.submit}
                  loginError={this.state.loginError}
                  resetAppErrorMessage={this.props.resetAppErrorMessage}
                  errorMessage={this.props.errorMessage}
                />
                <div className="padding-top-20" />
                <Table className={"table-no-margin table-no-border"}>
                  <Table.Body>
                    <Table.Row>
                      {settings.appName === LPPOLICE && (
                        <Table.Cell className={"table-no-padding"}>
                          <Link to="/createpassword" alt="New user link">
                            New User?
                          </Link>
                        </Table.Cell>
                      )}
                      <Table.Cell className={"table-no-padding"}>
                        <Link
                          // onClick={this.props.resetAppErrorMessage()}
                          to="/forgotpassword"
                          alt="Forgot password link"
                        >
                          Forgot Password?
                        </Link>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>

                <div className="padding-top-10" />

                <div className="padding-top-20 hide-on-smallscreen padding-top-3" />
              </div>

              <div className="col-lg-2 col-md-2 col-sm-2" />

              <div className="col-lg-4 col-md-4 col-sm-4 login-box-right padding-top-5">
                <div className="padding-top-35">{getContact()}</div>

                <div className="padding-top-20" />

                {/* <div className="col-lg-2 col-md-2 col-sm-2" /> */}
                
                {/* <div><p className="new-search-availability">New Searches Available: Try our <span className="red-text">Email/Social Searches</span> Now</p></div> */}
                {/* <div><p className="new-search-availability">New Searches Available: Try our <br/> <span className="red-text">Email and Social Media Searches now!</span></p></div> */}
                <div className="padding-top-20" />
                {messages.length > 0 ? (
                  <div
                    className="warning-message-box"
                    dangerouslySetInnerHTML={{ __html: messages }}
                  />
                ) : (
                  <div className="hide-on-smallscreen">
                    <div className="padding-top-20" />

                    <div className="padding-top-20" />

                    <div className="padding-top-20" />
                  </div>
                )}
                <div className="padding-top-20" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.user.token,
    errorMessage: state.appMessage && state.appMessage.errorMessage,
  };
}

export default connect(mapStateToProps, {
  login,
  isTokenValid,
  resetAppErrorMessage,
})(LoginPage);



// WEBPACK FOOTER //
// ./src/components/pages/LoginPage.js